<script setup lang="ts">
import { MenuSectionSocial } from '~/lib/services/content/footer/footer.dtos'
const props = defineProps<{ block: MenuSectionSocial }>()

const isMobile = inject('isMobile')

const specialContactButton = props.block.specialButtonContact

const items = computed(() => {
  if (!props.block.menuItemsSocial.length) return { social: undefined, apps: undefined }
  const [social, apps] = props.block.menuItemsSocial
  if (!apps)
    return {
      social,
      apps: undefined,
    }
  return { social, apps }
})
</script>

<template>
  <section class="flex max-w-[170px] flex-col gap-8">
    <p v-if="!isMobile" class="text-lg font-bold leading-6 tracking-[-0.15px]">
      {{ block.title }}
    </p>
    <SimpleLink v-if="specialContactButton" :link="specialContactButton">
      <McdButton
        class="flex w-36 items-center justify-center gap-2 rounded-md border-none bg-white py-3 shadow-elevation-down"
      >
        <img
          v-if="specialContactButton.icon?.url"
          class="w-4"
          :src="specialContactButton.icon?.url"
          :alt="specialContactButton.icon?.alternativeText ?? ''"
        />
        <p class="text-sm">{{ specialContactButton.title }}</p>
      </McdButton>
    </SimpleLink>
    <template v-if="items.social?.linkSocial.length">
      <section class="flex flex-col gap-4">
        <p v-if="!isMobile" class="text-balance text-sm leading-4 tracking-[-0.15px]">
          {{ items.social.content }}
        </p>
        <ul class="flex items-center gap-4 md:gap-2">
          <li v-for="(link, index) in items.social.linkSocial" :key="index">
            <a :href="link?.url || ''" :target="link?.blank ? '_blank' : '_self'">
              <span v-if="link?.icon === null">{{ link?.title }}</span>
              <img
                v-else
                class="h-auto w-6"
                :src="link?.icon?.url"
                :alt="link?.title !== null ? link?.title : ''"
              />
            </a>
          </li>
        </ul>
      </section>
    </template>

    <template v-if="items.apps?.linkSocial.length">
      <section class="flex flex-col gap-4">
        <p v-if="!isMobile" class="text-balance text-sm leading-4 tracking-[-0.15px]">
          {{ items.apps.content }}
        </p>
        <ul class="flex flex-row flex-wrap items-center gap-2">
          <li v-for="(link, index) in items.apps.linkSocial" :key="index" class="h-6 w-[77px]">
            <a :href="link?.url || ''" :target="link?.blank ? '_blank' : '_self'">
              <span v-if="link?.icon === null">{{ link?.title }}</span>
              <img
                v-else
                class="h-6 w-full"
                :src="link?.icon?.url"
                :alt="link?.title !== null ? link?.title : ''"
              />
            </a>
          </li>
        </ul>
      </section>
    </template>
  </section>
</template>
